export const SET_LAST_PRODUCT_CATEGORY_SLUG = 'SET_LAST_PRODUCT_CATEGORY_SLUG'
export const SET_SORT_OPTION = 'SET_SORT_OPTION'
export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT'
export const SET_LAST_COLLECTION_ID = 'SET_LAST_COLLECTION_ID'
